import React, { createContext, useState } from "react";

// Context State
interface NavigationContextState {
  dirtyFlag: boolean;
  preventNav: (() => Promise<void>) | null;
  updateDirtyFlag: (b: boolean) => void;
  updatePreventNav: any;
}

// Context
export const NavigationContext = createContext<NavigationContextState>({
  dirtyFlag: false,
  preventNav: null,
  updateDirtyFlag: () => {},
  updatePreventNav: () => {},
});

// Context Provider
const NavigationContextProvider: React.FunctionComponent<{
  children?: JSX.Element;
}> = (props) => {
  const [dirtyFlag, setDirtyFlag] = useState(false);
  const [preventNav, setPreventNav] = useState<(() => Promise<void>) | null>(null);

  const updateDirtyFlag = (b: boolean) => {
    setDirtyFlag(b);
  };

  const updatePreventNav = (func: () => Promise<void>) => {
    setPreventNav(() => func);
  };

  const { children } = props;

  return (
    <NavigationContext.Provider
      value={{
        dirtyFlag,
        preventNav,
        updateDirtyFlag,
        updatePreventNav,
      }}
    >
      {children}
    </NavigationContext.Provider>
  );
};

export default NavigationContextProvider;
